<script setup>
import { ref, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { debounce } from '@chatwoot/utils';
import SupportTicketsApi from 'dashboard/api/supportTickets';
import camelcaseKeys from 'camelcase-keys';
import ComboBox from 'dashboard/components-next/combobox/ComboBox.vue';

const props = defineProps({
  modelValue: { type: [Number, String], default: '' },
  hasError: { type: Boolean, default: false },
});

const emit = defineEmits(['update:modelValue']);

const { t } = useI18n();

const options = ref([]);
const isLoading = ref(false);

const fetchOptions = async (query = '') => {
  isLoading.value = true;
  try {
    const { data } = await SupportTicketsApi.conversationOptions({ q: query });
    const payload = camelcaseKeys(data.payload, { deep: true });
    options.value = payload.map(item => ({
      value: item.id,
      label: item.label,
    }));
  } finally {
    isLoading.value = false;
  }
};

const debouncedSearch = debounce(query => {
  fetchOptions(query);
}, 300);

const onSearch = query => {
  debouncedSearch(query);
};

const onOpen = () => {
  if (!options.value.length && !isLoading.value) {
    fetchOptions('');
  }
};

onMounted(() => {
  fetchOptions('');
});
</script>

<template>
  <ComboBox
    :model-value="modelValue"
    :options="options"
    use-api-results
    :has-error="hasError"
    :placeholder="t('SUPPORT_TICKETS.CONVERSATION_PLACEHOLDER')"
    :search-placeholder="t('SUPPORT_TICKETS.CONVERSATION_SEARCH')"
    :empty-state="t('SUPPORT_TICKETS.CONVERSATION_EMPTY')"
    @update:model-value="emit('update:modelValue', $event)"
    @search="onSearch"
    @open="onOpen"
  />
</template>
